/*
 * @Date: 2021-09-28 14:45:39
 * @Author: xuxiaofei
 * @LastEditTime: 2021-09-28 14:55:39
 * @LastEditors: xuxiaofei
 */
const api = {
  purchaser: {
    // 详情接口
    getBizDataDetails: {
      url: '/purchaser/mall/purSubmitBizData/getBizDataDetails',
      type: 'post'
    }
  },
  mall: {
    // 详情接口
    getBizDataDetails: {
      url: '/mall/purSubmitBizData/getBizDataDetails',
      type: 'post'
    }
  },
  supplier: {
    // 详情接口
    getBizDataDetails: {
      url: '/supplier/purSubmitBizData/getBizDataDetails',
      type: 'post'
    }
  }
}
export default api[window.fe.project]
